/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Reset_passwordRouteImport } from './routes/reset_password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as DevicesIndexRouteImport } from './routes/devices/index'
import { Route as OtpVerify_emailRouteImport } from './routes/otp/verify_email'
import { Route as OtpReset_passwordRouteImport } from './routes/otp/reset_password'
import { Route as OtpRegisterRouteImport } from './routes/otp/register'
import { Route as OtpErrorRouteImport } from './routes/otp/error'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'
import { Route as AuthPileRouteImport } from './routes/_auth/_pile'
import { Route as AuthGrainBinRouteImport } from './routes/_auth/_grain-bin'
import { Route as AuthBargeRouteImport } from './routes/_auth/_barge'
import { Route as AuthSplatRouteImport } from './routes/_auth/$'
import { Route as Unsubscribe_weekly_emailEmailUser_idRouteImport } from './routes/unsubscribe_weekly_email.$email.$user_id'
import { Route as DevicesFcCore_idRouteImport } from './routes/devices/fc.$core_id'
import { Route as AuthUserSettingsRouteImport } from './routes/_auth/user/settings'
import { Route as AuthUserPasswordRouteImport } from './routes/_auth/user/password'
import { Route as AuthUserNotificationsRouteImport } from './routes/_auth/user/notifications'
import { Route as AuthUserEmail_verificationRouteImport } from './routes/_auth/user/email_verification'
import { Route as AuthUserAccountRouteImport } from './routes/_auth/user/account'
import { Route as AuthAccountUsersRouteImport } from './routes/_auth/account/users'
import { Route as AuthGrainOperationsIndexRouteImport } from './routes/_auth/grain/operations/index'
import { Route as AuthGrainOperationsManageRouteImport } from './routes/_auth/grain/operations/manage'
import { Route as AuthPilePileSettingsRouteImport } from './routes/_auth/_pile/pile/settings'
import { Route as AuthPilePileExport_telemetryRouteImport } from './routes/_auth/_pile/pile/export_telemetry'
import { Route as AuthPilePileDevicesRouteImport } from './routes/_auth/_pile/pile/devices'
import { Route as AuthPilePileDashboardRouteImport } from './routes/_auth/_pile/pile/dashboard'
import { Route as AuthPilePileCreateRouteImport } from './routes/_auth/_pile/pile/create'
import { Route as AuthPilePileCablesRouteImport } from './routes/_auth/_pile/pile/cables'
import { Route as AuthPilePileCableRouteImport } from './routes/_auth/_pile/pile/cable'
import { Route as AuthGrainBinGrain_binTicketsRouteImport } from './routes/_auth/_grain-bin/grain_bin/tickets'
import { Route as AuthGrainBinGrain_binStorage_periodsRouteImport } from './routes/_auth/_grain-bin/grain_bin/storage_periods'
import { Route as AuthGrainBinGrain_binSettingsRouteImport } from './routes/_auth/_grain-bin/grain_bin/settings'
import { Route as AuthGrainBinGrain_binExport_telemetryRouteImport } from './routes/_auth/_grain-bin/grain_bin/export_telemetry'
import { Route as AuthGrainBinGrain_binEventsRouteImport } from './routes/_auth/_grain-bin/grain_bin/events'
import { Route as AuthGrainBinGrain_binDevicesRouteImport } from './routes/_auth/_grain-bin/grain_bin/devices'
import { Route as AuthGrainBinGrain_binDashboardRouteImport } from './routes/_auth/_grain-bin/grain_bin/dashboard'
import { Route as AuthGrainBinGrain_binCreateRouteImport } from './routes/_auth/_grain-bin/grain_bin/create'
import { Route as AuthGrainBinGrain_binAeration_scheduleRouteImport } from './routes/_auth/_grain-bin/grain_bin/aeration_schedule'
import { Route as AuthBargeBargeSettingsRouteImport } from './routes/_auth/_barge/barge/settings'
import { Route as AuthBargeBargeExport_telemetryRouteImport } from './routes/_auth/_barge/barge/export_telemetry'
import { Route as AuthBargeBargeDevicesRouteImport } from './routes/_auth/_barge/barge/devices'
import { Route as AuthBargeBargeDashboardRouteImport } from './routes/_auth/_barge/barge/dashboard'
import { Route as AuthBargeBargeCreateRouteImport } from './routes/_auth/_barge/barge/create'
import { Route as AuthBargeBargeCoversRouteImport } from './routes/_auth/_barge/barge/covers'
import { Route as AuthBargeBargeCoverRouteImport } from './routes/_auth/_barge/barge/cover'
import { Route as AuthGrainBinGrain_binWeather_forecastUser_idAccount_idGrain_bin_idRouteImport } from './routes/_auth/_grain-bin/grain_bin/weather_forecast.$user_id.$account_id.$grain_bin_id'
import { Route as AuthGrainBinGrain_binDashboard_analysisUser_idAccount_idGrain_bin_idRouteImport } from './routes/_auth/_grain-bin/grain_bin/dashboard_analysis.$user_id.$account_id.$grain_bin_id'

const Reset_passwordRoute = Reset_passwordRouteImport.update({
  id: '/reset_password',
  path: '/reset_password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const DevicesIndexRoute = DevicesIndexRouteImport.update({
  id: '/devices/',
  path: '/devices/',
  getParentRoute: () => rootRouteImport,
} as any)
const OtpVerify_emailRoute = OtpVerify_emailRouteImport.update({
  id: '/otp/verify_email',
  path: '/otp/verify_email',
  getParentRoute: () => rootRouteImport,
} as any)
const OtpReset_passwordRoute = OtpReset_passwordRouteImport.update({
  id: '/otp/reset_password',
  path: '/otp/reset_password',
  getParentRoute: () => rootRouteImport,
} as any)
const OtpRegisterRoute = OtpRegisterRouteImport.update({
  id: '/otp/register',
  path: '/otp/register',
  getParentRoute: () => rootRouteImport,
} as any)
const OtpErrorRoute = OtpErrorRouteImport.update({
  id: '/otp/error',
  path: '/otp/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPileRoute = AuthPileRouteImport.update({
  id: '/_pile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGrainBinRoute = AuthGrainBinRouteImport.update({
  id: '/_grain-bin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBargeRoute = AuthBargeRouteImport.update({
  id: '/_barge',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSplatRoute = AuthSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthRoute,
} as any)
const Unsubscribe_weekly_emailEmailUser_idRoute =
  Unsubscribe_weekly_emailEmailUser_idRouteImport.update({
    id: '/unsubscribe_weekly_email/$email/$user_id',
    path: '/unsubscribe_weekly_email/$email/$user_id',
    getParentRoute: () => rootRouteImport,
  } as any)
const DevicesFcCore_idRoute = DevicesFcCore_idRouteImport.update({
  id: '/devices/fc/$core_id',
  path: '/devices/fc/$core_id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthUserSettingsRoute = AuthUserSettingsRouteImport.update({
  id: '/user/settings',
  path: '/user/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUserPasswordRoute = AuthUserPasswordRouteImport.update({
  id: '/user/password',
  path: '/user/password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUserNotificationsRoute = AuthUserNotificationsRouteImport.update({
  id: '/user/notifications',
  path: '/user/notifications',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUserEmail_verificationRoute =
  AuthUserEmail_verificationRouteImport.update({
    id: '/user/email_verification',
    path: '/user/email_verification',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthUserAccountRoute = AuthUserAccountRouteImport.update({
  id: '/user/account',
  path: '/user/account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountUsersRoute = AuthAccountUsersRouteImport.update({
  id: '/account/users',
  path: '/account/users',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGrainOperationsIndexRoute =
  AuthGrainOperationsIndexRouteImport.update({
    id: '/grain/operations/',
    path: '/grain/operations/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGrainOperationsManageRoute =
  AuthGrainOperationsManageRouteImport.update({
    id: '/grain/operations/manage',
    path: '/grain/operations/manage',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPilePileSettingsRoute = AuthPilePileSettingsRouteImport.update({
  id: '/pile/settings',
  path: '/pile/settings',
  getParentRoute: () => AuthPileRoute,
} as any)
const AuthPilePileExport_telemetryRoute =
  AuthPilePileExport_telemetryRouteImport.update({
    id: '/pile/export_telemetry',
    path: '/pile/export_telemetry',
    getParentRoute: () => AuthPileRoute,
  } as any)
const AuthPilePileDevicesRoute = AuthPilePileDevicesRouteImport.update({
  id: '/pile/devices',
  path: '/pile/devices',
  getParentRoute: () => AuthPileRoute,
} as any)
const AuthPilePileDashboardRoute = AuthPilePileDashboardRouteImport.update({
  id: '/pile/dashboard',
  path: '/pile/dashboard',
  getParentRoute: () => AuthPileRoute,
} as any)
const AuthPilePileCreateRoute = AuthPilePileCreateRouteImport.update({
  id: '/pile/create',
  path: '/pile/create',
  getParentRoute: () => AuthPileRoute,
} as any)
const AuthPilePileCablesRoute = AuthPilePileCablesRouteImport.update({
  id: '/pile/cables',
  path: '/pile/cables',
  getParentRoute: () => AuthPileRoute,
} as any)
const AuthPilePileCableRoute = AuthPilePileCableRouteImport.update({
  id: '/pile/cable',
  path: '/pile/cable',
  getParentRoute: () => AuthPileRoute,
} as any)
const AuthGrainBinGrain_binTicketsRoute =
  AuthGrainBinGrain_binTicketsRouteImport.update({
    id: '/grain_bin/tickets',
    path: '/grain_bin/tickets',
    getParentRoute: () => AuthGrainBinRoute,
  } as any)
const AuthGrainBinGrain_binStorage_periodsRoute =
  AuthGrainBinGrain_binStorage_periodsRouteImport.update({
    id: '/grain_bin/storage_periods',
    path: '/grain_bin/storage_periods',
    getParentRoute: () => AuthGrainBinRoute,
  } as any)
const AuthGrainBinGrain_binSettingsRoute =
  AuthGrainBinGrain_binSettingsRouteImport.update({
    id: '/grain_bin/settings',
    path: '/grain_bin/settings',
    getParentRoute: () => AuthGrainBinRoute,
  } as any)
const AuthGrainBinGrain_binExport_telemetryRoute =
  AuthGrainBinGrain_binExport_telemetryRouteImport.update({
    id: '/grain_bin/export_telemetry',
    path: '/grain_bin/export_telemetry',
    getParentRoute: () => AuthGrainBinRoute,
  } as any)
const AuthGrainBinGrain_binEventsRoute =
  AuthGrainBinGrain_binEventsRouteImport.update({
    id: '/grain_bin/events',
    path: '/grain_bin/events',
    getParentRoute: () => AuthGrainBinRoute,
  } as any)
const AuthGrainBinGrain_binDevicesRoute =
  AuthGrainBinGrain_binDevicesRouteImport.update({
    id: '/grain_bin/devices',
    path: '/grain_bin/devices',
    getParentRoute: () => AuthGrainBinRoute,
  } as any)
const AuthGrainBinGrain_binDashboardRoute =
  AuthGrainBinGrain_binDashboardRouteImport.update({
    id: '/grain_bin/dashboard',
    path: '/grain_bin/dashboard',
    getParentRoute: () => AuthGrainBinRoute,
  } as any)
const AuthGrainBinGrain_binCreateRoute =
  AuthGrainBinGrain_binCreateRouteImport.update({
    id: '/grain_bin/create',
    path: '/grain_bin/create',
    getParentRoute: () => AuthGrainBinRoute,
  } as any)
const AuthGrainBinGrain_binAeration_scheduleRoute =
  AuthGrainBinGrain_binAeration_scheduleRouteImport.update({
    id: '/grain_bin/aeration_schedule',
    path: '/grain_bin/aeration_schedule',
    getParentRoute: () => AuthGrainBinRoute,
  } as any)
const AuthBargeBargeSettingsRoute = AuthBargeBargeSettingsRouteImport.update({
  id: '/barge/settings',
  path: '/barge/settings',
  getParentRoute: () => AuthBargeRoute,
} as any)
const AuthBargeBargeExport_telemetryRoute =
  AuthBargeBargeExport_telemetryRouteImport.update({
    id: '/barge/export_telemetry',
    path: '/barge/export_telemetry',
    getParentRoute: () => AuthBargeRoute,
  } as any)
const AuthBargeBargeDevicesRoute = AuthBargeBargeDevicesRouteImport.update({
  id: '/barge/devices',
  path: '/barge/devices',
  getParentRoute: () => AuthBargeRoute,
} as any)
const AuthBargeBargeDashboardRoute = AuthBargeBargeDashboardRouteImport.update({
  id: '/barge/dashboard',
  path: '/barge/dashboard',
  getParentRoute: () => AuthBargeRoute,
} as any)
const AuthBargeBargeCreateRoute = AuthBargeBargeCreateRouteImport.update({
  id: '/barge/create',
  path: '/barge/create',
  getParentRoute: () => AuthBargeRoute,
} as any)
const AuthBargeBargeCoversRoute = AuthBargeBargeCoversRouteImport.update({
  id: '/barge/covers',
  path: '/barge/covers',
  getParentRoute: () => AuthBargeRoute,
} as any)
const AuthBargeBargeCoverRoute = AuthBargeBargeCoverRouteImport.update({
  id: '/barge/cover',
  path: '/barge/cover',
  getParentRoute: () => AuthBargeRoute,
} as any)
const AuthGrainBinGrain_binWeather_forecastUser_idAccount_idGrain_bin_idRoute =
  AuthGrainBinGrain_binWeather_forecastUser_idAccount_idGrain_bin_idRouteImport.update(
    {
      id: '/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id',
      path: '/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id',
      getParentRoute: () => AuthGrainBinRoute,
    } as any,
  )
const AuthGrainBinGrain_binDashboard_analysisUser_idAccount_idGrain_bin_idRoute =
  AuthGrainBinGrain_binDashboard_analysisUser_idAccount_idGrain_bin_idRouteImport.update(
    {
      id: '/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id',
      path: '/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id',
      getParentRoute: () => AuthGrainBinRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthPileRouteWithChildren
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset_password': typeof Reset_passwordRoute
  '/$': typeof AuthSplatRoute
  '/dashboard': typeof AuthDashboardRoute
  '/otp/error': typeof OtpErrorRoute
  '/otp/register': typeof OtpRegisterRoute
  '/otp/reset_password': typeof OtpReset_passwordRoute
  '/otp/verify_email': typeof OtpVerify_emailRoute
  '/devices/': typeof DevicesIndexRoute
  '/account/users': typeof AuthAccountUsersRoute
  '/user/account': typeof AuthUserAccountRoute
  '/user/email_verification': typeof AuthUserEmail_verificationRoute
  '/user/notifications': typeof AuthUserNotificationsRoute
  '/user/password': typeof AuthUserPasswordRoute
  '/user/settings': typeof AuthUserSettingsRoute
  '/devices/fc/$core_id': typeof DevicesFcCore_idRoute
  '/unsubscribe_weekly_email/$email/$user_id': typeof Unsubscribe_weekly_emailEmailUser_idRoute
  '/barge/cover': typeof AuthBargeBargeCoverRoute
  '/barge/covers': typeof AuthBargeBargeCoversRoute
  '/barge/create': typeof AuthBargeBargeCreateRoute
  '/barge/dashboard': typeof AuthBargeBargeDashboardRoute
  '/barge/devices': typeof AuthBargeBargeDevicesRoute
  '/barge/export_telemetry': typeof AuthBargeBargeExport_telemetryRoute
  '/barge/settings': typeof AuthBargeBargeSettingsRoute
  '/grain_bin/aeration_schedule': typeof AuthGrainBinGrain_binAeration_scheduleRoute
  '/grain_bin/create': typeof AuthGrainBinGrain_binCreateRoute
  '/grain_bin/dashboard': typeof AuthGrainBinGrain_binDashboardRoute
  '/grain_bin/devices': typeof AuthGrainBinGrain_binDevicesRoute
  '/grain_bin/events': typeof AuthGrainBinGrain_binEventsRoute
  '/grain_bin/export_telemetry': typeof AuthGrainBinGrain_binExport_telemetryRoute
  '/grain_bin/settings': typeof AuthGrainBinGrain_binSettingsRoute
  '/grain_bin/storage_periods': typeof AuthGrainBinGrain_binStorage_periodsRoute
  '/grain_bin/tickets': typeof AuthGrainBinGrain_binTicketsRoute
  '/pile/cable': typeof AuthPilePileCableRoute
  '/pile/cables': typeof AuthPilePileCablesRoute
  '/pile/create': typeof AuthPilePileCreateRoute
  '/pile/dashboard': typeof AuthPilePileDashboardRoute
  '/pile/devices': typeof AuthPilePileDevicesRoute
  '/pile/export_telemetry': typeof AuthPilePileExport_telemetryRoute
  '/pile/settings': typeof AuthPilePileSettingsRoute
  '/grain/operations/manage': typeof AuthGrainOperationsManageRoute
  '/grain/operations/': typeof AuthGrainOperationsIndexRoute
  '/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id': typeof AuthGrainBinGrain_binDashboard_analysisUser_idAccount_idGrain_bin_idRoute
  '/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id': typeof AuthGrainBinGrain_binWeather_forecastUser_idAccount_idGrain_bin_idRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthPileRouteWithChildren
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset_password': typeof Reset_passwordRoute
  '/$': typeof AuthSplatRoute
  '/dashboard': typeof AuthDashboardRoute
  '/otp/error': typeof OtpErrorRoute
  '/otp/register': typeof OtpRegisterRoute
  '/otp/reset_password': typeof OtpReset_passwordRoute
  '/otp/verify_email': typeof OtpVerify_emailRoute
  '/devices': typeof DevicesIndexRoute
  '/account/users': typeof AuthAccountUsersRoute
  '/user/account': typeof AuthUserAccountRoute
  '/user/email_verification': typeof AuthUserEmail_verificationRoute
  '/user/notifications': typeof AuthUserNotificationsRoute
  '/user/password': typeof AuthUserPasswordRoute
  '/user/settings': typeof AuthUserSettingsRoute
  '/devices/fc/$core_id': typeof DevicesFcCore_idRoute
  '/unsubscribe_weekly_email/$email/$user_id': typeof Unsubscribe_weekly_emailEmailUser_idRoute
  '/barge/cover': typeof AuthBargeBargeCoverRoute
  '/barge/covers': typeof AuthBargeBargeCoversRoute
  '/barge/create': typeof AuthBargeBargeCreateRoute
  '/barge/dashboard': typeof AuthBargeBargeDashboardRoute
  '/barge/devices': typeof AuthBargeBargeDevicesRoute
  '/barge/export_telemetry': typeof AuthBargeBargeExport_telemetryRoute
  '/barge/settings': typeof AuthBargeBargeSettingsRoute
  '/grain_bin/aeration_schedule': typeof AuthGrainBinGrain_binAeration_scheduleRoute
  '/grain_bin/create': typeof AuthGrainBinGrain_binCreateRoute
  '/grain_bin/dashboard': typeof AuthGrainBinGrain_binDashboardRoute
  '/grain_bin/devices': typeof AuthGrainBinGrain_binDevicesRoute
  '/grain_bin/events': typeof AuthGrainBinGrain_binEventsRoute
  '/grain_bin/export_telemetry': typeof AuthGrainBinGrain_binExport_telemetryRoute
  '/grain_bin/settings': typeof AuthGrainBinGrain_binSettingsRoute
  '/grain_bin/storage_periods': typeof AuthGrainBinGrain_binStorage_periodsRoute
  '/grain_bin/tickets': typeof AuthGrainBinGrain_binTicketsRoute
  '/pile/cable': typeof AuthPilePileCableRoute
  '/pile/cables': typeof AuthPilePileCablesRoute
  '/pile/create': typeof AuthPilePileCreateRoute
  '/pile/dashboard': typeof AuthPilePileDashboardRoute
  '/pile/devices': typeof AuthPilePileDevicesRoute
  '/pile/export_telemetry': typeof AuthPilePileExport_telemetryRoute
  '/pile/settings': typeof AuthPilePileSettingsRoute
  '/grain/operations/manage': typeof AuthGrainOperationsManageRoute
  '/grain/operations': typeof AuthGrainOperationsIndexRoute
  '/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id': typeof AuthGrainBinGrain_binDashboard_analysisUser_idAccount_idGrain_bin_idRoute
  '/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id': typeof AuthGrainBinGrain_binWeather_forecastUser_idAccount_idGrain_bin_idRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset_password': typeof Reset_passwordRoute
  '/_auth/$': typeof AuthSplatRoute
  '/_auth/_barge': typeof AuthBargeRouteWithChildren
  '/_auth/_grain-bin': typeof AuthGrainBinRouteWithChildren
  '/_auth/_pile': typeof AuthPileRouteWithChildren
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/otp/error': typeof OtpErrorRoute
  '/otp/register': typeof OtpRegisterRoute
  '/otp/reset_password': typeof OtpReset_passwordRoute
  '/otp/verify_email': typeof OtpVerify_emailRoute
  '/devices/': typeof DevicesIndexRoute
  '/_auth/account/users': typeof AuthAccountUsersRoute
  '/_auth/user/account': typeof AuthUserAccountRoute
  '/_auth/user/email_verification': typeof AuthUserEmail_verificationRoute
  '/_auth/user/notifications': typeof AuthUserNotificationsRoute
  '/_auth/user/password': typeof AuthUserPasswordRoute
  '/_auth/user/settings': typeof AuthUserSettingsRoute
  '/devices/fc/$core_id': typeof DevicesFcCore_idRoute
  '/unsubscribe_weekly_email/$email/$user_id': typeof Unsubscribe_weekly_emailEmailUser_idRoute
  '/_auth/_barge/barge/cover': typeof AuthBargeBargeCoverRoute
  '/_auth/_barge/barge/covers': typeof AuthBargeBargeCoversRoute
  '/_auth/_barge/barge/create': typeof AuthBargeBargeCreateRoute
  '/_auth/_barge/barge/dashboard': typeof AuthBargeBargeDashboardRoute
  '/_auth/_barge/barge/devices': typeof AuthBargeBargeDevicesRoute
  '/_auth/_barge/barge/export_telemetry': typeof AuthBargeBargeExport_telemetryRoute
  '/_auth/_barge/barge/settings': typeof AuthBargeBargeSettingsRoute
  '/_auth/_grain-bin/grain_bin/aeration_schedule': typeof AuthGrainBinGrain_binAeration_scheduleRoute
  '/_auth/_grain-bin/grain_bin/create': typeof AuthGrainBinGrain_binCreateRoute
  '/_auth/_grain-bin/grain_bin/dashboard': typeof AuthGrainBinGrain_binDashboardRoute
  '/_auth/_grain-bin/grain_bin/devices': typeof AuthGrainBinGrain_binDevicesRoute
  '/_auth/_grain-bin/grain_bin/events': typeof AuthGrainBinGrain_binEventsRoute
  '/_auth/_grain-bin/grain_bin/export_telemetry': typeof AuthGrainBinGrain_binExport_telemetryRoute
  '/_auth/_grain-bin/grain_bin/settings': typeof AuthGrainBinGrain_binSettingsRoute
  '/_auth/_grain-bin/grain_bin/storage_periods': typeof AuthGrainBinGrain_binStorage_periodsRoute
  '/_auth/_grain-bin/grain_bin/tickets': typeof AuthGrainBinGrain_binTicketsRoute
  '/_auth/_pile/pile/cable': typeof AuthPilePileCableRoute
  '/_auth/_pile/pile/cables': typeof AuthPilePileCablesRoute
  '/_auth/_pile/pile/create': typeof AuthPilePileCreateRoute
  '/_auth/_pile/pile/dashboard': typeof AuthPilePileDashboardRoute
  '/_auth/_pile/pile/devices': typeof AuthPilePileDevicesRoute
  '/_auth/_pile/pile/export_telemetry': typeof AuthPilePileExport_telemetryRoute
  '/_auth/_pile/pile/settings': typeof AuthPilePileSettingsRoute
  '/_auth/grain/operations/manage': typeof AuthGrainOperationsManageRoute
  '/_auth/grain/operations/': typeof AuthGrainOperationsIndexRoute
  '/_auth/_grain-bin/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id': typeof AuthGrainBinGrain_binDashboard_analysisUser_idAccount_idGrain_bin_idRoute
  '/_auth/_grain-bin/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id': typeof AuthGrainBinGrain_binWeather_forecastUser_idAccount_idGrain_bin_idRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/error'
    | '/login'
    | '/privacy'
    | '/reset_password'
    | '/$'
    | '/dashboard'
    | '/otp/error'
    | '/otp/register'
    | '/otp/reset_password'
    | '/otp/verify_email'
    | '/devices/'
    | '/account/users'
    | '/user/account'
    | '/user/email_verification'
    | '/user/notifications'
    | '/user/password'
    | '/user/settings'
    | '/devices/fc/$core_id'
    | '/unsubscribe_weekly_email/$email/$user_id'
    | '/barge/cover'
    | '/barge/covers'
    | '/barge/create'
    | '/barge/dashboard'
    | '/barge/devices'
    | '/barge/export_telemetry'
    | '/barge/settings'
    | '/grain_bin/aeration_schedule'
    | '/grain_bin/create'
    | '/grain_bin/dashboard'
    | '/grain_bin/devices'
    | '/grain_bin/events'
    | '/grain_bin/export_telemetry'
    | '/grain_bin/settings'
    | '/grain_bin/storage_periods'
    | '/grain_bin/tickets'
    | '/pile/cable'
    | '/pile/cables'
    | '/pile/create'
    | '/pile/dashboard'
    | '/pile/devices'
    | '/pile/export_telemetry'
    | '/pile/settings'
    | '/grain/operations/manage'
    | '/grain/operations/'
    | '/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id'
    | '/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error'
    | '/login'
    | '/privacy'
    | '/reset_password'
    | '/$'
    | '/dashboard'
    | '/otp/error'
    | '/otp/register'
    | '/otp/reset_password'
    | '/otp/verify_email'
    | '/devices'
    | '/account/users'
    | '/user/account'
    | '/user/email_verification'
    | '/user/notifications'
    | '/user/password'
    | '/user/settings'
    | '/devices/fc/$core_id'
    | '/unsubscribe_weekly_email/$email/$user_id'
    | '/barge/cover'
    | '/barge/covers'
    | '/barge/create'
    | '/barge/dashboard'
    | '/barge/devices'
    | '/barge/export_telemetry'
    | '/barge/settings'
    | '/grain_bin/aeration_schedule'
    | '/grain_bin/create'
    | '/grain_bin/dashboard'
    | '/grain_bin/devices'
    | '/grain_bin/events'
    | '/grain_bin/export_telemetry'
    | '/grain_bin/settings'
    | '/grain_bin/storage_periods'
    | '/grain_bin/tickets'
    | '/pile/cable'
    | '/pile/cables'
    | '/pile/create'
    | '/pile/dashboard'
    | '/pile/devices'
    | '/pile/export_telemetry'
    | '/pile/settings'
    | '/grain/operations/manage'
    | '/grain/operations'
    | '/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id'
    | '/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id'
  id:
    | '__root__'
    | '/_auth'
    | '/error'
    | '/login'
    | '/privacy'
    | '/reset_password'
    | '/_auth/$'
    | '/_auth/_barge'
    | '/_auth/_grain-bin'
    | '/_auth/_pile'
    | '/_auth/dashboard'
    | '/otp/error'
    | '/otp/register'
    | '/otp/reset_password'
    | '/otp/verify_email'
    | '/devices/'
    | '/_auth/account/users'
    | '/_auth/user/account'
    | '/_auth/user/email_verification'
    | '/_auth/user/notifications'
    | '/_auth/user/password'
    | '/_auth/user/settings'
    | '/devices/fc/$core_id'
    | '/unsubscribe_weekly_email/$email/$user_id'
    | '/_auth/_barge/barge/cover'
    | '/_auth/_barge/barge/covers'
    | '/_auth/_barge/barge/create'
    | '/_auth/_barge/barge/dashboard'
    | '/_auth/_barge/barge/devices'
    | '/_auth/_barge/barge/export_telemetry'
    | '/_auth/_barge/barge/settings'
    | '/_auth/_grain-bin/grain_bin/aeration_schedule'
    | '/_auth/_grain-bin/grain_bin/create'
    | '/_auth/_grain-bin/grain_bin/dashboard'
    | '/_auth/_grain-bin/grain_bin/devices'
    | '/_auth/_grain-bin/grain_bin/events'
    | '/_auth/_grain-bin/grain_bin/export_telemetry'
    | '/_auth/_grain-bin/grain_bin/settings'
    | '/_auth/_grain-bin/grain_bin/storage_periods'
    | '/_auth/_grain-bin/grain_bin/tickets'
    | '/_auth/_pile/pile/cable'
    | '/_auth/_pile/pile/cables'
    | '/_auth/_pile/pile/create'
    | '/_auth/_pile/pile/dashboard'
    | '/_auth/_pile/pile/devices'
    | '/_auth/_pile/pile/export_telemetry'
    | '/_auth/_pile/pile/settings'
    | '/_auth/grain/operations/manage'
    | '/_auth/grain/operations/'
    | '/_auth/_grain-bin/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id'
    | '/_auth/_grain-bin/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ErrorRoute: typeof ErrorRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  Reset_passwordRoute: typeof Reset_passwordRoute
  OtpErrorRoute: typeof OtpErrorRoute
  OtpRegisterRoute: typeof OtpRegisterRoute
  OtpReset_passwordRoute: typeof OtpReset_passwordRoute
  OtpVerify_emailRoute: typeof OtpVerify_emailRoute
  DevicesIndexRoute: typeof DevicesIndexRoute
  DevicesFcCore_idRoute: typeof DevicesFcCore_idRoute
  Unsubscribe_weekly_emailEmailUser_idRoute: typeof Unsubscribe_weekly_emailEmailUser_idRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset_password': {
      id: '/reset_password'
      path: '/reset_password'
      fullPath: '/reset_password'
      preLoaderRoute: typeof Reset_passwordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devices/': {
      id: '/devices/'
      path: '/devices'
      fullPath: '/devices/'
      preLoaderRoute: typeof DevicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/otp/verify_email': {
      id: '/otp/verify_email'
      path: '/otp/verify_email'
      fullPath: '/otp/verify_email'
      preLoaderRoute: typeof OtpVerify_emailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/otp/reset_password': {
      id: '/otp/reset_password'
      path: '/otp/reset_password'
      fullPath: '/otp/reset_password'
      preLoaderRoute: typeof OtpReset_passwordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/otp/register': {
      id: '/otp/register'
      path: '/otp/register'
      fullPath: '/otp/register'
      preLoaderRoute: typeof OtpRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/otp/error': {
      id: '/otp/error'
      path: '/otp/error'
      fullPath: '/otp/error'
      preLoaderRoute: typeof OtpErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_pile': {
      id: '/_auth/_pile'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthPileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_grain-bin': {
      id: '/_auth/_grain-bin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthGrainBinRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_barge': {
      id: '/_auth/_barge'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthBargeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/$': {
      id: '/_auth/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthSplatRouteImport
      parentRoute: typeof AuthRoute
    }
    '/unsubscribe_weekly_email/$email/$user_id': {
      id: '/unsubscribe_weekly_email/$email/$user_id'
      path: '/unsubscribe_weekly_email/$email/$user_id'
      fullPath: '/unsubscribe_weekly_email/$email/$user_id'
      preLoaderRoute: typeof Unsubscribe_weekly_emailEmailUser_idRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devices/fc/$core_id': {
      id: '/devices/fc/$core_id'
      path: '/devices/fc/$core_id'
      fullPath: '/devices/fc/$core_id'
      preLoaderRoute: typeof DevicesFcCore_idRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/user/settings': {
      id: '/_auth/user/settings'
      path: '/user/settings'
      fullPath: '/user/settings'
      preLoaderRoute: typeof AuthUserSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/user/password': {
      id: '/_auth/user/password'
      path: '/user/password'
      fullPath: '/user/password'
      preLoaderRoute: typeof AuthUserPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/user/notifications': {
      id: '/_auth/user/notifications'
      path: '/user/notifications'
      fullPath: '/user/notifications'
      preLoaderRoute: typeof AuthUserNotificationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/user/email_verification': {
      id: '/_auth/user/email_verification'
      path: '/user/email_verification'
      fullPath: '/user/email_verification'
      preLoaderRoute: typeof AuthUserEmail_verificationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/user/account': {
      id: '/_auth/user/account'
      path: '/user/account'
      fullPath: '/user/account'
      preLoaderRoute: typeof AuthUserAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/account/users': {
      id: '/_auth/account/users'
      path: '/account/users'
      fullPath: '/account/users'
      preLoaderRoute: typeof AuthAccountUsersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/grain/operations/': {
      id: '/_auth/grain/operations/'
      path: '/grain/operations'
      fullPath: '/grain/operations/'
      preLoaderRoute: typeof AuthGrainOperationsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/grain/operations/manage': {
      id: '/_auth/grain/operations/manage'
      path: '/grain/operations/manage'
      fullPath: '/grain/operations/manage'
      preLoaderRoute: typeof AuthGrainOperationsManageRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_pile/pile/settings': {
      id: '/_auth/_pile/pile/settings'
      path: '/pile/settings'
      fullPath: '/pile/settings'
      preLoaderRoute: typeof AuthPilePileSettingsRouteImport
      parentRoute: typeof AuthPileRoute
    }
    '/_auth/_pile/pile/export_telemetry': {
      id: '/_auth/_pile/pile/export_telemetry'
      path: '/pile/export_telemetry'
      fullPath: '/pile/export_telemetry'
      preLoaderRoute: typeof AuthPilePileExport_telemetryRouteImport
      parentRoute: typeof AuthPileRoute
    }
    '/_auth/_pile/pile/devices': {
      id: '/_auth/_pile/pile/devices'
      path: '/pile/devices'
      fullPath: '/pile/devices'
      preLoaderRoute: typeof AuthPilePileDevicesRouteImport
      parentRoute: typeof AuthPileRoute
    }
    '/_auth/_pile/pile/dashboard': {
      id: '/_auth/_pile/pile/dashboard'
      path: '/pile/dashboard'
      fullPath: '/pile/dashboard'
      preLoaderRoute: typeof AuthPilePileDashboardRouteImport
      parentRoute: typeof AuthPileRoute
    }
    '/_auth/_pile/pile/create': {
      id: '/_auth/_pile/pile/create'
      path: '/pile/create'
      fullPath: '/pile/create'
      preLoaderRoute: typeof AuthPilePileCreateRouteImport
      parentRoute: typeof AuthPileRoute
    }
    '/_auth/_pile/pile/cables': {
      id: '/_auth/_pile/pile/cables'
      path: '/pile/cables'
      fullPath: '/pile/cables'
      preLoaderRoute: typeof AuthPilePileCablesRouteImport
      parentRoute: typeof AuthPileRoute
    }
    '/_auth/_pile/pile/cable': {
      id: '/_auth/_pile/pile/cable'
      path: '/pile/cable'
      fullPath: '/pile/cable'
      preLoaderRoute: typeof AuthPilePileCableRouteImport
      parentRoute: typeof AuthPileRoute
    }
    '/_auth/_grain-bin/grain_bin/tickets': {
      id: '/_auth/_grain-bin/grain_bin/tickets'
      path: '/grain_bin/tickets'
      fullPath: '/grain_bin/tickets'
      preLoaderRoute: typeof AuthGrainBinGrain_binTicketsRouteImport
      parentRoute: typeof AuthGrainBinRoute
    }
    '/_auth/_grain-bin/grain_bin/storage_periods': {
      id: '/_auth/_grain-bin/grain_bin/storage_periods'
      path: '/grain_bin/storage_periods'
      fullPath: '/grain_bin/storage_periods'
      preLoaderRoute: typeof AuthGrainBinGrain_binStorage_periodsRouteImport
      parentRoute: typeof AuthGrainBinRoute
    }
    '/_auth/_grain-bin/grain_bin/settings': {
      id: '/_auth/_grain-bin/grain_bin/settings'
      path: '/grain_bin/settings'
      fullPath: '/grain_bin/settings'
      preLoaderRoute: typeof AuthGrainBinGrain_binSettingsRouteImport
      parentRoute: typeof AuthGrainBinRoute
    }
    '/_auth/_grain-bin/grain_bin/export_telemetry': {
      id: '/_auth/_grain-bin/grain_bin/export_telemetry'
      path: '/grain_bin/export_telemetry'
      fullPath: '/grain_bin/export_telemetry'
      preLoaderRoute: typeof AuthGrainBinGrain_binExport_telemetryRouteImport
      parentRoute: typeof AuthGrainBinRoute
    }
    '/_auth/_grain-bin/grain_bin/events': {
      id: '/_auth/_grain-bin/grain_bin/events'
      path: '/grain_bin/events'
      fullPath: '/grain_bin/events'
      preLoaderRoute: typeof AuthGrainBinGrain_binEventsRouteImport
      parentRoute: typeof AuthGrainBinRoute
    }
    '/_auth/_grain-bin/grain_bin/devices': {
      id: '/_auth/_grain-bin/grain_bin/devices'
      path: '/grain_bin/devices'
      fullPath: '/grain_bin/devices'
      preLoaderRoute: typeof AuthGrainBinGrain_binDevicesRouteImport
      parentRoute: typeof AuthGrainBinRoute
    }
    '/_auth/_grain-bin/grain_bin/dashboard': {
      id: '/_auth/_grain-bin/grain_bin/dashboard'
      path: '/grain_bin/dashboard'
      fullPath: '/grain_bin/dashboard'
      preLoaderRoute: typeof AuthGrainBinGrain_binDashboardRouteImport
      parentRoute: typeof AuthGrainBinRoute
    }
    '/_auth/_grain-bin/grain_bin/create': {
      id: '/_auth/_grain-bin/grain_bin/create'
      path: '/grain_bin/create'
      fullPath: '/grain_bin/create'
      preLoaderRoute: typeof AuthGrainBinGrain_binCreateRouteImport
      parentRoute: typeof AuthGrainBinRoute
    }
    '/_auth/_grain-bin/grain_bin/aeration_schedule': {
      id: '/_auth/_grain-bin/grain_bin/aeration_schedule'
      path: '/grain_bin/aeration_schedule'
      fullPath: '/grain_bin/aeration_schedule'
      preLoaderRoute: typeof AuthGrainBinGrain_binAeration_scheduleRouteImport
      parentRoute: typeof AuthGrainBinRoute
    }
    '/_auth/_barge/barge/settings': {
      id: '/_auth/_barge/barge/settings'
      path: '/barge/settings'
      fullPath: '/barge/settings'
      preLoaderRoute: typeof AuthBargeBargeSettingsRouteImport
      parentRoute: typeof AuthBargeRoute
    }
    '/_auth/_barge/barge/export_telemetry': {
      id: '/_auth/_barge/barge/export_telemetry'
      path: '/barge/export_telemetry'
      fullPath: '/barge/export_telemetry'
      preLoaderRoute: typeof AuthBargeBargeExport_telemetryRouteImport
      parentRoute: typeof AuthBargeRoute
    }
    '/_auth/_barge/barge/devices': {
      id: '/_auth/_barge/barge/devices'
      path: '/barge/devices'
      fullPath: '/barge/devices'
      preLoaderRoute: typeof AuthBargeBargeDevicesRouteImport
      parentRoute: typeof AuthBargeRoute
    }
    '/_auth/_barge/barge/dashboard': {
      id: '/_auth/_barge/barge/dashboard'
      path: '/barge/dashboard'
      fullPath: '/barge/dashboard'
      preLoaderRoute: typeof AuthBargeBargeDashboardRouteImport
      parentRoute: typeof AuthBargeRoute
    }
    '/_auth/_barge/barge/create': {
      id: '/_auth/_barge/barge/create'
      path: '/barge/create'
      fullPath: '/barge/create'
      preLoaderRoute: typeof AuthBargeBargeCreateRouteImport
      parentRoute: typeof AuthBargeRoute
    }
    '/_auth/_barge/barge/covers': {
      id: '/_auth/_barge/barge/covers'
      path: '/barge/covers'
      fullPath: '/barge/covers'
      preLoaderRoute: typeof AuthBargeBargeCoversRouteImport
      parentRoute: typeof AuthBargeRoute
    }
    '/_auth/_barge/barge/cover': {
      id: '/_auth/_barge/barge/cover'
      path: '/barge/cover'
      fullPath: '/barge/cover'
      preLoaderRoute: typeof AuthBargeBargeCoverRouteImport
      parentRoute: typeof AuthBargeRoute
    }
    '/_auth/_grain-bin/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id': {
      id: '/_auth/_grain-bin/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id'
      path: '/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id'
      fullPath: '/grain_bin/weather_forecast/$user_id/$account_id/$grain_bin_id'
      preLoaderRoute: typeof AuthGrainBinGrain_binWeather_forecastUser_idAccount_idGrain_bin_idRouteImport
      parentRoute: typeof AuthGrainBinRoute
    }
    '/_auth/_grain-bin/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id': {
      id: '/_auth/_grain-bin/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id'
      path: '/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id'
      fullPath: '/grain_bin/dashboard_analysis/$user_id/$account_id/$grain_bin_id'
      preLoaderRoute: typeof AuthGrainBinGrain_binDashboard_analysisUser_idAccount_idGrain_bin_idRouteImport
      parentRoute: typeof AuthGrainBinRoute
    }
  }
}

interface AuthBargeRouteChildren {
  AuthBargeBargeCoverRoute: typeof AuthBargeBargeCoverRoute
  AuthBargeBargeCoversRoute: typeof AuthBargeBargeCoversRoute
  AuthBargeBargeCreateRoute: typeof AuthBargeBargeCreateRoute
  AuthBargeBargeDashboardRoute: typeof AuthBargeBargeDashboardRoute
  AuthBargeBargeDevicesRoute: typeof AuthBargeBargeDevicesRoute
  AuthBargeBargeExport_telemetryRoute: typeof AuthBargeBargeExport_telemetryRoute
  AuthBargeBargeSettingsRoute: typeof AuthBargeBargeSettingsRoute
}

const AuthBargeRouteChildren: AuthBargeRouteChildren = {
  AuthBargeBargeCoverRoute: AuthBargeBargeCoverRoute,
  AuthBargeBargeCoversRoute: AuthBargeBargeCoversRoute,
  AuthBargeBargeCreateRoute: AuthBargeBargeCreateRoute,
  AuthBargeBargeDashboardRoute: AuthBargeBargeDashboardRoute,
  AuthBargeBargeDevicesRoute: AuthBargeBargeDevicesRoute,
  AuthBargeBargeExport_telemetryRoute: AuthBargeBargeExport_telemetryRoute,
  AuthBargeBargeSettingsRoute: AuthBargeBargeSettingsRoute,
}

const AuthBargeRouteWithChildren = AuthBargeRoute._addFileChildren(
  AuthBargeRouteChildren,
)

interface AuthGrainBinRouteChildren {
  AuthGrainBinGrain_binAeration_scheduleRoute: typeof AuthGrainBinGrain_binAeration_scheduleRoute
  AuthGrainBinGrain_binCreateRoute: typeof AuthGrainBinGrain_binCreateRoute
  AuthGrainBinGrain_binDashboardRoute: typeof AuthGrainBinGrain_binDashboardRoute
  AuthGrainBinGrain_binDevicesRoute: typeof AuthGrainBinGrain_binDevicesRoute
  AuthGrainBinGrain_binEventsRoute: typeof AuthGrainBinGrain_binEventsRoute
  AuthGrainBinGrain_binExport_telemetryRoute: typeof AuthGrainBinGrain_binExport_telemetryRoute
  AuthGrainBinGrain_binSettingsRoute: typeof AuthGrainBinGrain_binSettingsRoute
  AuthGrainBinGrain_binStorage_periodsRoute: typeof AuthGrainBinGrain_binStorage_periodsRoute
  AuthGrainBinGrain_binTicketsRoute: typeof AuthGrainBinGrain_binTicketsRoute
  AuthGrainBinGrain_binDashboard_analysisUser_idAccount_idGrain_bin_idRoute: typeof AuthGrainBinGrain_binDashboard_analysisUser_idAccount_idGrain_bin_idRoute
  AuthGrainBinGrain_binWeather_forecastUser_idAccount_idGrain_bin_idRoute: typeof AuthGrainBinGrain_binWeather_forecastUser_idAccount_idGrain_bin_idRoute
}

const AuthGrainBinRouteChildren: AuthGrainBinRouteChildren = {
  AuthGrainBinGrain_binAeration_scheduleRoute:
    AuthGrainBinGrain_binAeration_scheduleRoute,
  AuthGrainBinGrain_binCreateRoute: AuthGrainBinGrain_binCreateRoute,
  AuthGrainBinGrain_binDashboardRoute: AuthGrainBinGrain_binDashboardRoute,
  AuthGrainBinGrain_binDevicesRoute: AuthGrainBinGrain_binDevicesRoute,
  AuthGrainBinGrain_binEventsRoute: AuthGrainBinGrain_binEventsRoute,
  AuthGrainBinGrain_binExport_telemetryRoute:
    AuthGrainBinGrain_binExport_telemetryRoute,
  AuthGrainBinGrain_binSettingsRoute: AuthGrainBinGrain_binSettingsRoute,
  AuthGrainBinGrain_binStorage_periodsRoute:
    AuthGrainBinGrain_binStorage_periodsRoute,
  AuthGrainBinGrain_binTicketsRoute: AuthGrainBinGrain_binTicketsRoute,
  AuthGrainBinGrain_binDashboard_analysisUser_idAccount_idGrain_bin_idRoute:
    AuthGrainBinGrain_binDashboard_analysisUser_idAccount_idGrain_bin_idRoute,
  AuthGrainBinGrain_binWeather_forecastUser_idAccount_idGrain_bin_idRoute:
    AuthGrainBinGrain_binWeather_forecastUser_idAccount_idGrain_bin_idRoute,
}

const AuthGrainBinRouteWithChildren = AuthGrainBinRoute._addFileChildren(
  AuthGrainBinRouteChildren,
)

interface AuthPileRouteChildren {
  AuthPilePileCableRoute: typeof AuthPilePileCableRoute
  AuthPilePileCablesRoute: typeof AuthPilePileCablesRoute
  AuthPilePileCreateRoute: typeof AuthPilePileCreateRoute
  AuthPilePileDashboardRoute: typeof AuthPilePileDashboardRoute
  AuthPilePileDevicesRoute: typeof AuthPilePileDevicesRoute
  AuthPilePileExport_telemetryRoute: typeof AuthPilePileExport_telemetryRoute
  AuthPilePileSettingsRoute: typeof AuthPilePileSettingsRoute
}

const AuthPileRouteChildren: AuthPileRouteChildren = {
  AuthPilePileCableRoute: AuthPilePileCableRoute,
  AuthPilePileCablesRoute: AuthPilePileCablesRoute,
  AuthPilePileCreateRoute: AuthPilePileCreateRoute,
  AuthPilePileDashboardRoute: AuthPilePileDashboardRoute,
  AuthPilePileDevicesRoute: AuthPilePileDevicesRoute,
  AuthPilePileExport_telemetryRoute: AuthPilePileExport_telemetryRoute,
  AuthPilePileSettingsRoute: AuthPilePileSettingsRoute,
}

const AuthPileRouteWithChildren = AuthPileRoute._addFileChildren(
  AuthPileRouteChildren,
)

interface AuthRouteChildren {
  AuthSplatRoute: typeof AuthSplatRoute
  AuthBargeRoute: typeof AuthBargeRouteWithChildren
  AuthGrainBinRoute: typeof AuthGrainBinRouteWithChildren
  AuthPileRoute: typeof AuthPileRouteWithChildren
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthAccountUsersRoute: typeof AuthAccountUsersRoute
  AuthUserAccountRoute: typeof AuthUserAccountRoute
  AuthUserEmail_verificationRoute: typeof AuthUserEmail_verificationRoute
  AuthUserNotificationsRoute: typeof AuthUserNotificationsRoute
  AuthUserPasswordRoute: typeof AuthUserPasswordRoute
  AuthUserSettingsRoute: typeof AuthUserSettingsRoute
  AuthGrainOperationsManageRoute: typeof AuthGrainOperationsManageRoute
  AuthGrainOperationsIndexRoute: typeof AuthGrainOperationsIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSplatRoute: AuthSplatRoute,
  AuthBargeRoute: AuthBargeRouteWithChildren,
  AuthGrainBinRoute: AuthGrainBinRouteWithChildren,
  AuthPileRoute: AuthPileRouteWithChildren,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthAccountUsersRoute: AuthAccountUsersRoute,
  AuthUserAccountRoute: AuthUserAccountRoute,
  AuthUserEmail_verificationRoute: AuthUserEmail_verificationRoute,
  AuthUserNotificationsRoute: AuthUserNotificationsRoute,
  AuthUserPasswordRoute: AuthUserPasswordRoute,
  AuthUserSettingsRoute: AuthUserSettingsRoute,
  AuthGrainOperationsManageRoute: AuthGrainOperationsManageRoute,
  AuthGrainOperationsIndexRoute: AuthGrainOperationsIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ErrorRoute: ErrorRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  Reset_passwordRoute: Reset_passwordRoute,
  OtpErrorRoute: OtpErrorRoute,
  OtpRegisterRoute: OtpRegisterRoute,
  OtpReset_passwordRoute: OtpReset_passwordRoute,
  OtpVerify_emailRoute: OtpVerify_emailRoute,
  DevicesIndexRoute: DevicesIndexRoute,
  DevicesFcCore_idRoute: DevicesFcCore_idRoute,
  Unsubscribe_weekly_emailEmailUser_idRoute:
    Unsubscribe_weekly_emailEmailUser_idRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
